// extracted by mini-css-extract-plugin
export default {"wrapper":"login-page_wrapper__qhw98","contentWrapper":"login-page_contentWrapper__t+jJm","loading":"login-page_loading__Wp7g-","l":"login-page_l__oL+HO"};